/*
  BS VIP-Anzeige (LENA-BS, 16.10.2026, Auftrag Johannes)
  Nachfolger von assets/discount_generic.js aus dem alten Dawn-Theme #142827618571.
  Kommt jemand über einen Creator-Link (/discount/CODE), setzt Shopify das Cookie
  discount_code. Steht der Code unten in der Liste, zeigt dieses Skript:
    - oben einen gelben Balken „Dein VIP-Code … ist aktiv“
    - an jedem Preis (Produktübersicht, Produktseite, „Passt dazu“) den alten
      Preis durchgestrichen, den VIP-Preis und eine kleine Marke „VIP: CODE“
    - auf den VIP-Kollektionsseiten „VIP-Code: CODE“ als Überschrift
  Den Rabatt selbst rechnet Shopify an der Kasse, das hier ist nur die Anzeige.
  Neuer Creator-Code: eine Zeile in CODES ergänzen (Groß-/Kleinschreibung egal).
  cat = Seite, auf die der Balken verlinkt. Seit 21.10.2026 alle auf /collections/code,
  die alten VIP-Kollektionen sind gelöscht (Johannes).
  b1g2 = BUY1-GET2-Code. Der gilt in Shopify nur für die Produkte in B1G2_PRODUKTE
  (kein Game Changer, keine 30 ml, keine Schönheitsfehler), dort zeigen wir auch
  keinen VIP-Preis. Neues Produkt für BUY1-GET2: hier und an den Rabatten ergänzen.
*/
(function () {
  var CODES = {
    "joda": { cat: "code", dis: 20 },
    "pokemon": { cat: "code", dis: 90 },
    "PAAVO20": { cat: "code", dis: 99 },
    "paavo20": { cat: "code", dis: 20 },
    "Emilyluisa20": { cat: "code", dis: 20 },
    "Masha20": { cat: "code", dis: 20 },
    "Aileen20": { cat: "code", dis: 20 },
    "Annamari20": { cat: "code", dis: 20 },
    "Leonie20": { cat: "code", dis: 20 },
    "Mutti20": { cat: "code", dis: 20 },
    "Lea20": { cat: "code", dis: 20 },
    "Jennifer20": { cat: "code", dis: 20 },
    "Babsi20": { cat: "code", dis: 20 },
    "Sissi20": { cat: "code", dis: 20 },
    "Verena20": { cat: "code", dis: 20 },
    "Dietz20": { cat: "code", dis: 20 },
    "Judith20": { cat: "code", dis: 20 },
    "claudia20": { cat: "code", dis: 20 },
    "Janine20": { cat: "code", dis: 20 },
    "Julia20": { cat: "code", dis: 20 },
    "Google20": { cat: "code", dis: 20 },
    "Insta20": { cat: "code", dis: 20 },
    "claudia50": { cat: "code", b1g2: true, dis: 50 },
    "sweet50": { cat: "code", b1g2: true, dis: 50 },
    "mood30": { cat: "code", b1g2: true, dis: 30 },
    "mood50": { cat: "code", b1g2: true, dis: 50 },
    "kate50": { cat: "code", b1g2: true, dis: 50 },
    "svenja50": { cat: "code", b1g2: true, dis: 50 },
    "nina50": { cat: "code", b1g2: true, dis: 50 },
    "elisabeth50": { cat: "code", b1g2: true, dis: 50 },
    "mone50": { cat: "code", b1g2: true, dis: 50 },
    "hannah50": { cat: "code", b1g2: true, dis: 50 },
    "anna50": { cat: "code", b1g2: true, dis: 50 },
    "alex-j50": { cat: "code", b1g2: true, dis: 50 },
    "ulli50": { cat: "code", b1g2: true, dis: 50 },
    "pomponetti50": { cat: "code", b1g2: true, dis: 50 },
    "lori50": { cat: "code", b1g2: true, dis: 50 },
    "BEAUTIFULSCENTS": { cat: "code", dis: 20 },
    "katharina50": { cat: "code", b1g2: true, dis: 50 },
    "frieda24": { cat: "code", dis: 24 },
    "lynn24": { cat: "code", dis: 24 },
    "harmony24": { cat: "code", dis: 24 },
    "joy24": { cat: "code", dis: 24 },
    "relax24": { cat: "code", dis: 24 },
    "selflove24": { cat: "code", dis: 24 },
    "goodluck24": { cat: "code", dis: 24 },
    "anja24": { cat: "code", dis: 24 },
    "lynn20": { cat: "code", dis: 20 },
    "juli24": { cat: "code", dis: 24 },
    "uls24": { cat: "code", dis: 24 },
    "xmas30": { cat: "code", dis: 30 },
    "happy25": { cat: "code", dis: 25 },
    "superpower": { cat: "code", dis: 15 },
    "stephie24": { cat: "code", dis: 24 },
    "mone24": { cat: "code", dis: 24 },
    "claudia24": { cat: "code", dis: 24 },
    "love24": { cat: "code", dis: 24 },
    "kati24": { cat: "code", dis: 24 },
    "nina24": { cat: "code", dis: 24 },
    "happy24": { cat: "code-nl", dis: 24 },
    "women30": { cat: "code", dis: 30 },
    "ostern30": { cat: "code", dis: 30 },
    "janina30": { cat: "code", dis: 30 },
    "claudia30": { cat: "code", dis: 30 },
    "svenja30": { cat: "code", dis: 30 },
    "kate30": { cat: "code", dis: 30 },
    "maxi30": { cat: "code", dis: 30 },
    "sandra30": { cat: "code", dis: 30 },
    "elisabeth30": { cat: "code", dis: 30 },
    "katrin30": { cat: "code", dis: 30 },
    "sweetliving30": { cat: "code", dis: 30 },
    "nina30": { cat: "code", dis: 30 },
    "jana30": { cat: "code", dis: 30 },
    "mimi30": { cat: "code", dis: 30 },
    "hannah30": { cat: "code", dis: 30 },
    "pomponetti30": { cat: "code", dis: 30 },
    "juli30": { cat: "code", dis: 30 },
    "lori30": { cat: "code", dis: 30 },
    "uli30": { cat: "code", dis: 30 },
    "alexa30": { cat: "code", dis: 30 },
    "julia30": { cat: "code", dis: 30 },
    "kati30": { cat: "code", dis: 30 },
    "svenja24": { cat: "code", dis: 24 },
    "fearless50OFF": { cat: "code", dis: 50 },
    "summer44": { cat: "code", dis: 44 },
    "elisabeth44": { cat: "code", dis: 44 },
    "svenja44": { cat: "code", dis: 44 },
    "juli44": { cat: "code", dis: 44 },
    "susanne44": { cat: "code", dis: 44 },
    "lori44": { cat: "code", dis: 44 },
    "sandra44": { cat: "code", dis: 44 },
    "claudia44": { cat: "code", dis: 44 },
    "hannah44": { cat: "code", dis: 44 },
    "kate44": { cat: "code", dis: 44 },
    "oktoberfest30": { cat: "code", dis: 30 },
    "XXXXXXX": { cat: "code", dis: 44 },
    "katharina30": { cat: "code", dis: 30 },
    "valeska30": { cat: "code", dis: 30 },
    "claudi30": { cat: "code", dis: 30 },
    "anja30": { cat: "code", dis: 30 },
    "rike30": { cat: "code", dis: 30 },
    "netti30": { cat: "code", dis: 30 },
    "sue30": { cat: "code", dis: 30 },
    "susanne30": { cat: "code", dis: 30 },
    "hera30": { cat: "code", dis: 30 },
    "happy26": { cat: "code", dis: 26 },
    "danke30": { cat: "code", dis: 30 },
    "ostern26": { cat: "code", dis: 26 },
    "mama30": { cat: "code", dis: 30 },
    "nike25": { cat: "code", dis: 30 },
    "sommer30": { cat: "code", dis: 30 },
    "vera30": { cat: "code", dis: 30 },
    "vera25": { cat: "code", dis: 25 },
    "buy1-get2": { cat: "code", b1g2: true, dis: 50 }
  };

  function keks(name) {
    var teile = document.cookie.split(';');
    for (var i = 0; i < teile.length; i++) {
      var t = teile[i].trim();
      if (t.indexOf(name + '=') === 0) {
        try { return decodeURIComponent(t.substring(name.length + 1)); } catch (e) { return t.substring(name.length + 1); }
      }
    }
    return null;
  }

  var roh = keks('discount_code');
  if (!roh) return;
  var schluessel = null;
  for (var k in CODES) { if (k.toLowerCase() === roh.toLowerCase()) { schluessel = k; break; } }
  if (!schluessel) return;
  var code = roh;
  var rabatt = CODES[schluessel].dis;
  var ziel = '/collections/' + CODES[schluessel].cat;
  var b1g2 = !!CODES[schluessel].b1g2;
  var B1G2_PRODUKTE = ["abundance", "abundance-kopie", "bonne-voyage-set-minis-3er-set", "ease", "fearless", "good-luck", "happygolucky-set", "harmony", "joy", "newstart", "readyforsuccess-set", "relax", "reset", "selflove", "success", "superpower-set-2er-set"];

  // Handle des Produkts, zu dem ein Preis gehört: nächster Produktlink in der
  // Karte, sonst die Produktseite selbst (Kaufknopf, Umschalter, Kaufleiste).
  function produktVon(el) {
    var knoten = el;
    for (var i = 0; i < 8 && knoten && knoten !== document.body; i++) {
      var a = knoten.matches && knoten.matches('a[href*="/products/"]') ? knoten : knoten.querySelector && knoten.querySelector('a[href*="/products/"]');
      if (a) return (a.getAttribute('href').match(/\/products\/([^/?#]+)/) || [])[1];
      knoten = knoten.parentElement;
    }
    return (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
  }

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]; }); }

  var waehrung = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var format = new Intl.NumberFormat('de-DE', { style: 'currency', currency: waehrung });

  var stil = document.createElement('style');
  stil.textContent =
    // Dunkel mit Code in Akzentgelb, damit sich der Balken von der gelben Hello Bar abhebt (Johannes 16.10.2026).
    '.bs-vip-balken{display:block;padding:9px 16px;background:#14110f;color:#fff;text-align:center;font-size:13px;line-height:1.3;letter-spacing:.02em;text-decoration:none}' +
    '.bs-vip-balken b{font-weight:600;color:#fbe99f}' +
    '.bs-vip-alt{text-decoration:line-through;opacity:.55;font-weight:400;margin-right:6px}' +
    '.bs-vip-neu{font-weight:600}' +
    // Die Section setzt den Kartenpreis per ID-Selektor auf nowrap, daher !important.
    '.bs-po-karte__preis[data-bs-vip]{flex-basis:100%!important;margin-left:0!important;white-space:normal!important;text-align:left!important}' +
    '.bs-po-karte__preis[data-bs-vip] .bs-vip-pille{margin-left:0;margin-top:3px;display:table}' +
    // VIP-Marke im Akzentgelb (Johannes 16.10.2026).
    '.bs-vip-pille{display:inline-block;margin-left:6px;padding:2px 8px;border-radius:999px;background:#fbe99f;color:#14110f;font-size:.62em;font-weight:600;letter-spacing:.04em;vertical-align:middle;white-space:nowrap}';
  document.head.appendChild(stil);

  function balken() {
    if (document.querySelector('.bs-vip-balken')) return;
    var a = document.createElement('a');
    a.className = 'bs-vip-balken';
    a.href = ziel;
    a.innerHTML = 'Dein VIP-Code <b>' + esc(code) + '</b> ist aktiv: ' + rabatt + ' % Rabatt';
    // In die .page-wrapper statt in den body (Johannes 16.10.2026): Horizon scrollt
    // die .page-wrapper mit fester Höhe 100dvh. Stand der Balken davor, war die Seite
    // um seine Höhe zu lang und unten wurde der Footer abgeschnitten.
    var huelle = document.querySelector('.page-wrapper') || document.body;
    huelle.insertBefore(a, huelle.firstChild);
  }

  // Letzter Geldbetrag im Text = aktueller Preis (davor kann ein Streichpreis stehen).
  function betrag(text) {
    var treffer = text.match(/\d{1,3}(?:\.\d{3})*,\d{2}/g);
    if (!treffer) return null;
    return parseFloat(treffer[treffer.length - 1].replace(/\./g, '').replace(',', '.'));
  }

  // Neue Karten (Übersicht, „Passt dazu“), Produktseite, und Horizons Standardkarten
  // auf den Aktionsseiten. Warenkorb bewusst nicht: dort rechnet Shopify selbst.
  var ZIELE = '.bs-po-karte__preis, .bs-pd__preis, product-card .price, .bs-pd__knopfpreis, .bs-gs__preis, .sticky-add-to-cart__price .price';
  function preise() {
    document.querySelectorAll(ZIELE).forEach(function (el) {
      if (el.closest('cart-drawer-component, .cart-drawer, #cart-drawer, .cart-items')) return;
      // Schon umgebaut und seitdem unverändert: nichts tun. Hat das Theme den
      // Preis neu geschrieben (z. B. Variantenwechsel), gilt der neue Text.
      if (el.dataset.bsVip === '1' && el.textContent === el.dataset.bsVipText) return;
      if (b1g2 && B1G2_PRODUKTE.indexOf(produktVon(el)) === -1) return;
      var original = el.innerHTML;
      var wert = betrag(el.textContent);
      if (wert === null) return;
      var neu = Math.round(wert * (100 - rabatt)) / 100;
      el.dataset.bsVip = '1';
      if (el.matches('.bs-pd__knopfpreis, .bs-gs__preis, .sticky-add-to-cart__price .price')) {
        // Im Kaufknopf, im Größen-Umschalter und in der Kaufleiste ist kein Platz
        // für Streichpreis und Marke, dort steht nur der VIP-Preis (Johannes 16.10.2026).
        el.textContent = format.format(neu);
      } else {
        el.innerHTML = '<span class="bs-vip-alt">' + original + '</span>' +
          '<span class="bs-vip-neu">' + format.format(neu) + '</span>' +
          '<span class="bs-vip-pille">VIP: ' + esc(code) + '</span>';
      }
      el.dataset.bsVipText = el.textContent;
    });
  }

  // VIP-Kollektionsseiten: Titel „vip-code“ bzw. „VIP Code: …“ und das fette
  // „VIP Code“ im Beschreibungstext bekommen den echten Code (wie im alten Theme).
  function ueberschrift() {
    if (location.pathname.indexOf('/collections/vip-code') !== 0) return;
    var main = document.querySelector('main') || document.body;
    main.querySelectorAll('h1, h2, p, strong, b').forEach(function (el) {
      if (el.children.length) return;
      var t = el.textContent.trim();
      if (/^vip-code/i.test(t) || /^VIP Code:/i.test(t)) el.textContent = 'VIP-Code: ' + code;
      else if (/^VIP Code$/i.test(t)) el.textContent = 'VIP-Code ' + code;
    });
  }

  // VIP-Kopf (sections/bs-vip-kopf.liquid): Code und Prozente einsetzen.
  function kopf() {
    document.querySelectorAll('[data-bs-vip-kopf]').forEach(function (k) {
      k.querySelectorAll('[data-bs-vip-code]').forEach(function (e) { e.textContent = code; });
      k.querySelectorAll('[data-bs-vip-prozent]').forEach(function (e) { e.textContent = rabatt; });
      k.querySelectorAll('[data-bs-vip-zeile]').forEach(function (e) { e.setAttribute('data-aktiv', ''); });
    });
  }

  function alles() { balken(); preise(); ueberschrift(); kopf(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alles); else alles();

  // Variantenwechsel, Warenkorb-Leiste und nachgeladene Abschnitte zeichnen Preise neu.
  var wartet = false;
  new MutationObserver(function () {
    if (wartet) return;
    wartet = true;
    requestAnimationFrame(function () { wartet = false; preise(); });
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
